const customProjects = [
  {
    title: "Dôme Glamping Nature",
    price: "€49,000",
    features: [
      "Emplacement isolé en pleine nature – idéal pour une expérience glamping",
      "Dôme géodésique de 20 m² : utilisable toute l’année, excellente isolation thermique et acoustique",
      "Terrasse en bois + piscine privée",
      "Espace nuit, coin salon, kitchenette et salle de bain",
      "Compatible avec les raccordements en eau et électricité",
      "Parfait pour un usage touristique, camping ou personnel",
    ],
    size: "20 m²",
    images: ["/images/1a.jpeg", "/images/1c.jpeg", "/images/1d.jpeg", "/images/1e.jpeg", "/images/1g.jpeg", "/images/1h.jpeg", "/images/1i.jpeg"],
    guarantee: null,
    finalNote:
      "Ce modèle est construit sur mesure selon vos besoins et vos envies par Groupe KLC.",
  },
  {
    title: "A-Frame Serenity",
    price: "€74,000",
    size: "35 m²",
    images: ["/images/2a.jpeg", "/images/2b.jpeg", "/images/2c.jpeg", "/images/2d.jpeg", "/images/2f.jpeg", "/images/2h.jpeg", "/images/2i.jpeg", "/images/2k.jpeg"],
    features: [
      "Architecture iconique en A parfaitement intégrée à l’environnement naturel",
      "1 chambre confortable",
      "Un salon ouvert avec kitchenette entièrement équipée",
      "Une salle de bain moderne avec douche",
      "Terrasse en bois de 25 m² avec espace repas & détente",
      "Piscine privée et jardin paysager",
      "Structure bois hautement isolée – confort garanti toute l’année",
      "Façade vitrée panoramique pour une lumière naturelle abondante",
      "Compatible avec tous les réseaux : électricité, eau, évacuation",
    ],

    guarantee: null,
    finalNote:
      "Ce modèle est conçu et construit sur mesure par Groupe KLC, selon vos besoins et vos envies.",
  },
  {
    title: "A-Frame Rivière",
    price: "€82,000",
    size: "55 m²",
    images: ["/images/3b.jpeg", "/images/3a.jpeg", "/images/3d.jpeg", "/images/3e.jpeg", "/images/3f.jpeg", "/images/3g.jpeg", "/images/3h.jpeg", "/images/3i.jpeg", "/images/3k.jpeg"],
    features: [
      "Emplacement exceptionnel en pleine nature, au bord d’un ruisseau",
      "Grande chambre confortable",
      "Salon ouvert avec cuisine entièrement équipée",
      "Salle de bain moderne",
      "Terrasse en bois de 30 m² + kiosque suspendu au-dessus de la rivière",
      "Jardin avec hamac et coin détente",
      "Structure en bois haut de gamme – isolée pour un confort toute l’année",
      "Raccordements complets : eau, électricité, évacuation",
    ],
    guarantee: "Garantie structurelle de 20 ans",
    finalNote:
      "Ce modèle est conçu et réalisé sur mesure par Groupe KLC, selon vos envies et vos besoins.",
  },
  {
    title: "A-Frame Deluxe Infinity",
    price: "€119,000",
    size: "85 m²",
    images: ["/images/4b.jpeg", "/images/4a.jpeg", "/images/4c.jpeg", "/images/4e.jpeg", "/images/4f.jpeg", "/images/4g.jpeg", "/images/4h.jpeg", "/images/4i.jpeg", "/images/4k.jpeg"],
    features: [
      "Villa A-frame moderne à 2 étages au design exceptionnel",
      "2 grandes chambres à l’étage",
      "Salon ouvert avec cuisine équipée",
      "Salle de bain élégante + WC séparé",
      "Balcon panoramique de 20 m² + terrasse en bois de 30 m²",
      "Piscine privée + jardin paysager",
      "Pré-équipement pour jacuzzi extérieur inclus",
      "Structure en bois renforcée par acier – isolation optimale pour 4 saisons",
      "Raccordements complets : eau, électricité, évacuation",
    ],
    guarantee: "Garantie structurelle de 20 ans",
    finalNote:
      "Ce modèle est conçu et réalisé sur mesure par Groupe KLC, selon votre terrain et vos besoins.",
  },
  {
    title: "A-Frame Palm Retreat",
    price: "€119,000",
    size: "65 m² habitables + 30 m² de terrasse",
    images: ["/images/5e.jpeg", "/images/5a.jpeg", "/images/5b.jpeg", "/images/5c.jpeg", "/images/5d.jpeg", "/images/5f.jpeg", "/images/5g.jpeg", "/images/5h.jpeg", "/images/5i.jpeg", "/images/5k.jpeg"],
    features: [
      "Espace de vie totalement clos et isolé, axé sur le calme et l’intimité",
      "Grande chambre avec lit king-size",
      "Salon ouvert avec coin cheminée",
      "Cuisine moderne (four, plaques, réfrigérateur inclus)",
      "Salle de bain avec douche + rangements intégrés",
      "Jardin tropical paysagé avec palmiers",
      "Piscine privée (option chauffée disponible)",
      "Espace détente avec transats, hamac, coin salon extérieur",
      "Grande façade vitrée offrant lumière naturelle et vue dégagée",
      "Structure isolée – conçue pour un confort 4 saisons",
      "Entièrement raccordée aux réseaux : eau, électricité, évacuation",
    ],
    guarantee: "Garantie de 20 ans sur la structure et l’isolation",
    finalNote:
      "Ce modèle est conçu et construit sur mesure par Groupe KLC, selon votre terrain, votre mode de vie et vos besoins.",
  },
  {
    title: "Chalet Rustique Nature",
    price: "€29,000",
    size: "40 m²",
    images: ["/images/6a.jpeg", "/images/6b.jpeg", "/images/6c.jpeg", "/images/6e.jpeg", "/images/6f.jpeg", "/images/6g.jpeg", "/images/6h.jpeg", "/images/6i.jpeg", "/images/6k.jpeg"],
    features: [
      "Style chalet de montagne – compact, chaleureux et proche de la nature",
      "1 chambre + salon ouvert",
      "Coin cuisine + salle de bain avec douche",
      "Espace piscine entouré de pierres naturelles + coin détente",
      "Piscine privée + pelouse",
      "Façade en bois massif et structure sur base pierre robuste",
      "Idéal pour un projet de tourisme rural, bungalow ou résidence secondaire",
      "Compatible avec les réseaux : eau, électricité, évacuation",
    ],
    guarantee: "Garantie structurelle de 20 ans",
    finalNote:
      "Ce modèle est conçu et réalisé sur mesure par Groupe KLC, en fonction de vos besoins et de votre budget.",
  },
  {
    title: "A-Frame Zen Poolhouse",
    price: "€109,000",
    size: "Surface habitable de 70 m² + terrasse de 35 m²",
    images: ["/images/7a.jpeg", "/images/7b.jpeg", "/images/7c.jpeg", "/images/7d.jpeg", "/images/7e.jpeg", "/images/7f.jpeg", "/images/7h.jpeg", "/images/7i.jpeg", "/images/7k.jpeg"],
    features: [
      "Maison A-frame moderne au design inspiré des spas et du bien-être",
      "Grande chambre",
      "Salon ouvert avec cuisine équipée",
      "Salle de bain luxueuse avec douche et finitions en pierre naturelle",
      "Grande piscine + zone séparée pour enfants",
      "Espace solarium avec chaises longues et hamac",
      "Façade en bois naturel + baies vitrées pour une lumière optimale",
      "Isolation thermique et humidité renforcée – utilisable toute l’année",
      "Raccordements complets (eau, électricité, évacuation)",
    ],
    guarantee: "Garantie structurelle de 20 ans",
    finalNote:
      "Ce modèle est conçu et construit sur mesure par Groupe KLC, selon votre terrain, votre usage et vos préférences.",
  },
  {
    title: "Cottage Élégance Blue",
    price: "€67,000",
    size: "50 m² + 20 m² de terrasse",
    images: ["/images/8a.jpeg", "/images/8b.jpeg", "/images/8c.jpeg", "/images/8f.jpeg", "/images/8h.jpeg", "/images/8i.jpeg"],
    features: [
      "Maison paisible au style raffiné, idéale pour s’éloigner du quotidien",
      "1 chambre",
      "Salon avec cheminée",
      "Cuisine moderne et salle de bain équipée",
      "Architecture élégante avec plafond haut et cheminée en pierre",
      "Jardin aménagé avec coin détente, hamac et espace repas",
      "Piscine privative à l’arrière avec terrasse relaxante",
      "Parfaitement isolée – utilisable toute l’année",
      "Raccordements complets (eau, électricité, évacuation)",
    ],
    guarantee: "Garantie structurelle et d’isolation de 20 ans incluse",
    finalNote:
      "Ce modèle est conçu et réalisé sur mesure par Groupe KLC selon vos envies, votre budget et votre terrain.",
  },
  {
    title: "A-Frame Urban Chic",
    price: "€97,000",
    size: "60 m² + 25 m² de terrasse",
    images: ["/images/9a.jpeg", "/images/9b.jpeg", "/images/9c.jpeg", "/images/9d.jpeg", "/images/9e.jpeg", "/images/9f.jpeg"],
    features: [
      "Maison moderne au design épuré, mêlant confort et esthétique",
      "1 chambre",
      "Salon spacieux avec cuisine ouverte",
      "Salle de bain moderne + plafond cathédrale",
      "Piscine privée + jardin paysager avec mobilier en fer forgé",
      "Détails extérieurs haut de gamme : bardage bois, cheminée en pierre, toiture design",
      "Raccordements complets : eau, électricité, évacuation",
    ],
    guarantee: "Garantie de 20 ans sur la structure et l’isolation",
    finalNote:
      "Ce modèle est conçu et réalisé sur mesure par Groupe KLC, selon votre terrain, vos goûts et vos besoins.",
  },
  {
    title: "Stone Glass Retreat",
    price: "€129,000",
    size: "75 m² + terrasse de 35 m²",
    images: ["/images/10h.jpeg", "/images/10a.jpeg", "/images/10b.jpeg", "/images/10c.jpeg", "/images/10d.jpeg", "/images/10e.jpeg", "/images/10f.jpeg", "/images/10g.jpeg", "/images/10i.jpeg"],
    features: [
      "Façade en pierre naturelle combinée à une architecture vitrée – alliance parfaite de l’élégance et de la robustesse",
      "Grande chambre",
      "Salon ouvert avec façade vitrée panoramique",
      "Cuisine moderne entièrement équipée",
      "Salle de bain spacieuse avec grande douche",
      "Piscine privée avec cascade intégrée",
      "Espace détente extérieur avec salon de jardin et transats",
      "Raccordements complets : eau, électricité, évacuation",
    ],
    guarantee: "Garantie de 20 ans sur la structure",
    finalNote:
      "Ce modèle est conçu et réalisé sur mesure par Groupe KLC, clé en main selon vos besoins et votre terrain.",
  },
];

export default customProjects;
